/**
 * Safe Area Provider
 * Automatically handles safe area insets for iOS and Android
 * No manual CSS required - uses CSS env() variables automatically
 * Works on both iOS and Android when viewport-fit=cover is set
 * 
 * CSS env() variables are natively supported on:
 * - iOS 11+ (all modern iOS devices)
 * - Android Chrome 69+ (all modern Android devices)
 * 
 * @author Varun Pandey
 */

import { ReactNode } from 'react';

interface SafeAreaProviderProps {
  children: ReactNode;
}

export function SafeAreaProvider({ children }: SafeAreaProviderProps) {
  // Use CSS env() variables which are automatically available on iOS and Android
  // when viewport-fit=cover is set in the meta tag (already done in index.html)
  // These work natively without any plugin on modern devices
  const style: React.CSSProperties = {
    paddingTop: 'env(safe-area-inset-top, 0px)',
    paddingLeft: 'env(safe-area-inset-left, 0px)',
    paddingRight: 'env(safe-area-inset-right, 0px)',
    minHeight: '100dvh',
    boxSizing: 'border-box',
  };

  return (
    <div style={style} className="safe-area-provider">
      {children}
    </div>
  );
}
